import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AppLayout } from "./components/AppLayout";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { AuthProvider } from "./contexts/AuthContext";
import { AddRatingPage } from "./pages/AddRatingPage";
import { DashboardPage } from "./pages/DashboardPage";
import { LoginPage } from "./pages/LoginPage";
import { MyRatingsPage } from "./pages/MyRatingsPage";
import { ProfilePage } from "./pages/ProfilePage";

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 30_000,
			retry: 1,
		},
	},
});

export default function App() {
	return (
		<QueryClientProvider client={queryClient}>
			<AuthProvider>
				<BrowserRouter>
					<Routes>
						<Route path="/login" element={<LoginPage />} />
						<Route element={<ProtectedRoute />}>
							<Route element={<AppLayout />}>
								<Route path="/" element={<DashboardPage />} />
								<Route path="/ratings" element={<MyRatingsPage />} />
								<Route path="/profile" element={<ProfilePage />} />
							</Route>
							<Route path="/ratings/new" element={<AddRatingPage />} />
							<Route path="/ratings/:id" element={<AddRatingPage />} />
						</Route>
					</Routes>
				</BrowserRouter>
			</AuthProvider>
		</QueryClientProvider>
	);
}
